import Layout from "../../components/layOutWrapper/layOutWrapper";
import ShowTravelAllowanceRequest from "../../components/travelAllowanceRequests/showTravelAllowanceRequest";

export default function ParticularTravelAllowanceRequestView () {
    return (
        <>
            <Layout children={<ShowTravelAllowanceRequest/>} sectionTitle="Solicitud de viático"/>
        </>
    )
}